import { useTranslation } from "react-i18next";
import { Box, Text } from "@mantine/core";
import { ArrowLeft } from "lucide-react";

export const LoanPending = ({
  goBack,
  form,
}: {
  goBack: () => void;
  form: any;
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <Box
        sx={{
          cursor: "pointer",
          marginBottom: "32px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 0",
        }}
        onClick={goBack}
      >
        <ArrowLeft size={24} />
        <Text fz={24} fw={600}>
          {t("OPEN_DEPOSIT_ACCOUNT")}
        </Text>
      </Box>
      {form}
    </div>
  );
};
